__turbopack_context__.v({
  "active": "NavLink-module__J2wrgG__active",
  "link": "NavLink-module__J2wrgG__link",
  "underline": "NavLink-module__J2wrgG__underline",
});
